import React, { createContext, useContext, ReactNode } from "react";
import { useHappyHourMessage } from "./hooks/useHappyHourMessage";
import { HappyHourMessagesByLocation } from "./types/HappyHour.interface";
import { useHappyHourVisibility } from "./hooks/useHappyHourVisibility";

interface HappyHourContextValue {
  data?: HappyHourMessagesByLocation;
  loading?: boolean;
  refresh: () => void;
  topBannerClosed?: boolean;
  setTopBannerClosed?: React.Dispatch<React.SetStateAction<boolean>>;
}

const HappyHourContext = createContext<HappyHourContextValue>({
  refresh: () => {},
});

export const useHappyHourContext = () => {
  return useContext(HappyHourContext);
};

interface HappyHourProviderProps {
  children: ReactNode;
}

export const HappyHourProvider = ({ children }: HappyHourProviderProps) => {
  const { data, loading, fetchHappyHour } = useHappyHourMessage();
  const filteredData = useHappyHourVisibility(data || {});
  const [topBannerClosed, setTopBannerClosed] = React.useState(false);

  return (
    <HappyHourContext.Provider
      value={{
        data: filteredData,
        loading,
        refresh: fetchHappyHour,
        topBannerClosed,
        setTopBannerClosed,
      }}
    >
      {children}
    </HappyHourContext.Provider>
  );
};
